import './../css/main.sass';
import 'bootstrap/js/dist/dropdown'
import './partials/navbar.js'
import { initMap } from './map'

// Collapsible List
let coll = document.getElementsByClassName("collapsible");
let i;

for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
        this.classList.toggle("collapsibleopen");
        let content = this.nextElementSibling;
        if (content.style.maxHeight) {
            content.style.maxHeight = null;
        } else {
            content.style.maxHeight = content.scrollHeight + "px";
        }
    });
}

// Back to top
window.addEventListener('scroll', function(){
    event.preventDefault();
    if ($(this).scrollTop() >= 50) {
            $('#backToTop').fadeIn(200);
            $('.cookie-data').addClass('cookie-data-animation')
        } else {
            $('#BackToTop').fadeOut(200);
            $('.cookie-data').removeClass('cookie-data-animation')
        }
    });

    
$('#backToTop').click(function() {
    $('body,html').animate({
        scrollTop: 0
    }, 500);
});

$('#cookie-bot-btn').unbind('click');
$('#cookie-bot-btn').click(function() {
    $('#cookie-data-wrap').toggleClass('donot-display');
});

$('#link-parken').addClass('active');

window.onload = function() {
    $(document).ready(function() {
        initMap()
    })
};